<form #f="ngForm" (keydown.enter)="(false)">
  <div fxLayout="column" fxLayoutGap="16px">
    <h1 mat-dialog-title>{{ (editMode ? 'global.edit_organization' : 'global.add_organization') | translate }}</h1>
    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'global.company_id' | translate }}"
        [(ngModel)]="organization.id"
        name="id"
        [disabled]="editMode"
        required
        gtAlphanumericValidator
        gtMaxCharactersValidator
        #id="ngModel"
      />
      <mat-error *ngIf="id.invalid && id.errors.message">{{ id.errors.message | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'global.company_name' | translate }}"
        [(ngModel)]="organization.name"
        name="name"
        required
        gtAlphanumericValidator
      />
      <mat-error>{{ 'validator.alphanumeric.error' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-select
        placeholder="{{ 'admin.settings.service_provider' | translate }}"
        [(ngModel)]="organization.provider"
        name="provider"
      >
        <mat-option *ngFor="let provider of providers" [value]="provider">
          {{ provider }}
        </mat-option>
      </mat-select>
      <mat-error>{{ 'validator.required.error' | translate }}</mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
      <mat-form-field fxFlex="50">
        <mat-select placeholder="Inbound service" [(ngModel)]="organization.euInService" name="euInService" required>
          <mat-option *ngFor="let service of inboundServices" [value]="service">
            {{ service }}
          </mat-option>
        </mat-select>
        <mat-error>{{ 'validator.required.error' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="50">
        <mat-select placeholder="Outbound service" [(ngModel)]="organization.euOutService" name="euOutService" required>
          <mat-option *ngFor="let service of outboundServices" [value]="service">
            {{ service }}
          </mat-option>
        </mat-select>
        <mat-error>{{ 'validator.required.error' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="hasServiceProviderCtiPush">
      <mat-form-field fxFlex>
        <input matInput placeholder="{{ 'admin.settings.cti_push_url' | translate }}" [(ngModel)]="ctiPushUrl" name="ctiPushUrl" />
      </mat-form-field>
      <mat-icon title="{{ 'admin.settings.cti_push_url.description' | translate }}"> help_outline </mat-icon>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="5px" *ngIf="editMode">
      <div fxLayout="column" fxLayoutGap="5px">
        <mat-slide-toggle
          [(ngModel)]="hasSwitchboard"
          name="hasSwitchboard"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.switchboard' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="hasVipList" name="hasVipList" color="primary" [disabled]="!hasServiceProviderCompanyFeatureToggle">
          {{ 'admin.settings.vip_list' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          [(ngModel)]="hasWallboard"
          name="hasWallboard"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.wallboard' | translate }}
        </mat-slide-toggle>
      </div>

      <div fxLayout="column" fxLayoutGap="5px">
        <mat-slide-toggle
          [(ngModel)]="hasConferenceReservation"
          name="hasConferenceReservation"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.conference_reservation' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          [(ngModel)]="hasConferenceAdHoc"
          name="hasConferenceAdHoc"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.conference_ad_hoc' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          *ngIf="hasServiceProviderMicrosoftSync"
          [(ngModel)]="hasMicrosoftSync"
          name="hasMicrosoftSync"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.mss' | translate }}
        </mat-slide-toggle>

        <mat-slide-toggle
          *ngIf="hasServiceProviderNumberLookup"
          [(ngModel)]="hasNumberLookup"
          name="hasNumberLookup"
          color="primary"
          [disabled]="!hasServiceProviderCompanyFeatureToggle"
        >
          {{ 'admin.settings.number_lookup' | translate }}
        </mat-slide-toggle>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="5px">
      <button mat-button (click)="onCancelClick()" color="primary" class="btn btn-default">
        {{ 'global.cancel' | translate }}
      </button>
      <button mat-raised-button (click)="saveCompanySettings()" color="primary" class="btn btn-default" [disabled]="f.invalid">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</form>
